import React, { useState } from 'react';
import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react';

interface NewsSummaryProps {
  /** HTML do campo `resumo` (RichText do behavior `noticia_meta`). */
  html?: string;
}

/** Um resumo só de tags vazias não vira card. */
const temConteudo = (html?: string): boolean =>
  Boolean(html && html.replace(/<[^>]*>/g, '').trim());

/**
 * Card sanfonado "Ver resumo" / "Resumo".
 *
 * `<details>`/`<summary>` nativos: funcionam sem JS e já vêm com a semântica de
 * expansão para leitor de tela — o mesmo caminho do formulário de filtros da
 * listagem. O estado local só existe para trocar o rótulo e o ícone.
 */
export const NewsSummary: React.FC<NewsSummaryProps> = ({ html }) => {
  const [aberto, setAberto] = useState(false);

  if (!temConteudo(html)) {
    return null;
  }

  return (
    <details
      className={`mpf-news__summary${aberto ? ' mpf-news__summary--open' : ''}`}
      onToggle={(event) =>
        setAberto((event.currentTarget as HTMLDetailsElement).open)
      }
    >
      <summary className="mpf-news__summary-header">
        <span className="mpf-news__summary-title">
          {aberto ? 'Resumo' : 'Ver resumo'}
        </span>
        {aberto ? (
          <CaretUpIcon size={18} aria-hidden="true" />
        ) : (
          <CaretDownIcon size={18} aria-hidden="true" />
        )}
      </summary>
      <div
        className="mpf-news__summary-body"
        // Conteúdo do RichText, escrito pela redação no editor do Plone.
        dangerouslySetInnerHTML={{ __html: html as string }}
      />
    </details>
  );
};

export default NewsSummary;
